import { ChainConfig } from "@silo/types";
import { satisfies } from "effect/Function";
import { TOKEN_ADDRESS } from "../token-address";

export const arbitrum = satisfies<ChainConfig>()({
  tokens: {
    [TOKEN_ADDRESS.arbitrum.USDC_e]: {
      symbol: "USDC.e",
      name: "Bridged USDC",
    },
    [TOKEN_ADDRESS.arbitrum.DPX]: {
      name: "Dopex",
    },
    [TOKEN_ADDRESS.arbitrum.SILO]: {
      name: "SILO",
      symbol: "SILO",
    },
    [TOKEN_ADDRESS.arbitrum.WOO]: {
      name: "WOO",
    },
    [TOKEN_ADDRESS.arbitrum.PTeETH]: {
      name: "Etherfi • Pendle",
      symbol: "PT-eETH (25 Apr)",
    },
    [TOKEN_ADDRESS.arbitrum.PTezETH]: {
      symbol: "PT-ezETH (27 Jun)",
      name: "Renzo • Pendle",
    },
    [TOKEN_ADDRESS.arbitrum.ezETH]: {
      name: "Renzo",
    },
    [TOKEN_ADDRESS.arbitrum.PTweETH]: {
      name: "Etherfi • Pendle",
      symbol: "PT-eETH (27 Jun)",
    },
    [TOKEN_ADDRESS.arbitrum.PTrsETH]: {
      name: "Kelp • Pendle",
      symbol: "PT-rsETH (27 Jun)",
    },
    [TOKEN_ADDRESS.arbitrum.PTUSDe]: {
      name: "Ethena • Pendle",
      symbol: "PT-USDe (29 Aug)",
    },
    [TOKEN_ADDRESS.arbitrum.PTezETH_SEPT2024]: {
      name: "Renzo • Pendle",
      symbol: "PT-ezETH (26 Sept)",
    },
    [TOKEN_ADDRESS.arbitrum.PTweETH_SEPT2024]: {
      name: "Etherfi • Pendle",
      symbol: "PT-eETH (26 Sept)",
    },
    [TOKEN_ADDRESS.arbitrum.PTrsETH_SEPT2024]: {
      name: "Kelp • Pendle",
      symbol: "PT-rsETH (26 Sept)",
    },
    [TOKEN_ADDRESS.arbitrum.ptUSDE_NOV2024]: {
      name: "Ethena • Pendle",
      symbol: "PT-USDe (28 Nov)",
    },
    [TOKEN_ADDRESS.arbitrum.PTweETH_DEC2024]: {
      name: "Etherfi • Pendle",
      symbol: "PT-eETH (26 Dec)",
    },
    [TOKEN_ADDRESS.arbitrum.PTrsETH_DEC2024]: {
      name: "Kelp • Pendle",
      symbol: "PT-rsETH (26 Dec)",
    },
    [TOKEN_ADDRESS.arbitrum.PTweETH_JUN2025]: {
      name: "Etherfi • Pendle",
      symbol: "PT-eETH (26 Jun 2025)",
    },
    [TOKEN_ADDRESS.arbitrum.PTrsETH_JUN2025]: {
      name: "Kelp • Pendle",
      symbol: "PT-rsETH (26 Jun 2025)",
    },
    [TOKEN_ADDRESS.arbitrum.gmETH]: {
      symbol: "gmETH",
    },
  },
} as const);
